/**
 * Admin user management API.
 */
import { adminGet, adminPost } from './admin-ajax';

export interface AdminUser {
  user_id: string;
  username: string | null;
  email: string | null;
  credits_balance: number;
  created_at: string | null;
  is_active: boolean;
}

export interface AdminUserListResponse {
  items: AdminUser[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export interface AdminCreditRecord {
  id: string;
  created_at: string | null;
  credit_cost: number;
  total_cost_usd: number;
  is_increase: boolean;
  before_balance: number;
  after_balance: number;
  biz_type: string | null;
  biz_type_label: string | null;
  description: string | null;
  total_tokens: number;
  model_names: string[] | null;
  model_name: string | null;
  input_tokens: number;
  output_tokens: number;
  cached_tokens: number;
}

export interface AdminCreditRecordListResponse {
  items: AdminCreditRecord[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

export const listUsers = (params: {
  q?: string;
  page?: number;
  page_size?: number;
  sort_by?: string;
  sort_order?: string;
}, options?: { signal?: AbortSignal }) =>
  adminGet<AdminUserListResponse>('/api/admin/users', params, options);

export const listUserCreditRecords = (userId: string, params: {
  page?: number;
  page_size?: number;
  biz_type?: string;
}, options?: { signal?: AbortSignal }) => adminGet<AdminCreditRecordListResponse>(
  `/api/admin/users/${encodeURIComponent(userId)}/credit_records`,
  params,
  options
);

export const grantCredits = (userId: string, amount: number, reason: string) =>
  adminPost<{ user_id: string; balance: number; record_id: string }>(
    `/api/admin/users/${encodeURIComponent(userId)}/credit_grants`,
    { amount, reason }
  );
